import React from 'react'
import { getLeftPercent, getWidthPercent } from './timelineConstants'
import { SegmentedBlock, Segment } from './SegmentedBlock'
import { formatTimeHHmm } from '../../../shared/lib/timeline/dateHelpers'

const BREAK_DURATION = 30
const BREAK_COLOR = '#94A3B8'

interface Props {
  startTimeIso: string
  onMouseDown?: (e: React.MouseEvent) => void
  className?: string
  laneIndex?: number
  laneCount?: number
}

export const BreakBlock = ({ startTimeIso, onMouseDown, className, laneIndex, laneCount }: Props) => {
  const left = getLeftPercent(startTimeIso)
  const width = getWidthPercent(BREAK_DURATION)

  const segments: Segment[] = [
    { duration: BREAK_DURATION, color: BREAK_COLOR, topLabel: formatTimeHHmm(startTimeIso), label: 'Pause' },
  ]

  return (
    <SegmentedBlock
      segments={segments}
      left={left}
      width={width}
      className={`${onMouseDown ? 'cursor-grab' : ''} ${className ?? ''}`}
      onMouseDown={onMouseDown}
      laneIndex={laneIndex}
      laneCount={laneCount}
    />
  )
}
